import { web3 } from "./account";
import { connectWallet } from "./account";
import { erc20ABI, nftPresaleABI } from "./abi";
import { usdtContractAddress , nftPresaleContractAddress} from "./contracts";
const nftContract = new web3.eth.Contract(nftPresaleContractAddress , nftPresaleABI);

export const getTotalMinted = async () => {
    try {
        const  value =  parseFloat(
            web3.utils.fromWei(await nftContract.methods._weiRaised().call(), "ether")
          ).toFixed(2);
          return value;
    } catch (error) {
        return "0"
    }
}